<!-- cv简历信息表-基本信息-组件级 -->
<template>
  <div class='detail-wrap'>
    <div class='detail-container'>
      <div class='cv-detail en'>
        <ul>
          <li>
            <span class='cv-detail-name'>Mentee Email：</span>
            <span class='cv-detail-val'>{{baseInfoDetailEn.email}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>CD Name：</span>
            <span class='cv-detail-val'>{{baseTeamInfoDetailEn.cd && baseTeamInfoDetailEn.cd.name ? baseTeamInfoDetailEn.cd.name : 'N/A'}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>CD Email：</span>
            <span class='cv-detail-val'>{{baseTeamInfoDetailEn.cd && baseTeamInfoDetailEn.cd.email ? baseTeamInfoDetailEn.cd.email : 'N/A'}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>SEC Name：</span>
            <span class='cv-detail-val'>{{baseTeamInfoDetailEn.sec && baseTeamInfoDetailEn.sec.name ? baseTeamInfoDetailEn.sec.name : 'N/A'}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>SEC Email：</span>
            <span class='cv-detail-val'>{{baseTeamInfoDetailEn.sec && baseTeamInfoDetailEn.sec.email ? baseTeamInfoDetailEn.sec.email : 'N/A'}}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import cvService from '@/api/undergraduate/cv'
import './cv-detail.less'
export default {
  name: '',
  components: {},
  data () {
    return {
      // 学员num
      menteeNum: '',
      // 个人详情
      baseInfoDetailEn: {},
      baseTeamInfoDetailEn: {
        cd: {},
        sec: {}
      }
    }
  },
  computed: {},
  mounted () {
    this.menteeNum = this.$route.params.id
    this.getBaseInfoRDetailEn()
    this.getBaseTeamInfoRDetailEn()
  },
  methods: {
    // 获取基本信息
    getBaseInfoRDetailEn () {
      cvService.cvBaseInfoDetailEn({ num: this.menteeNum }).then(res => {
        if (res.data.model) {
          this.baseInfoDetailEn = res.data.model
        }
      }).catch(error => {
        this.$ugd_message(error.message, 'error')
      })
    },
    // 获取团队信息
    getBaseTeamInfoRDetailEn () {
      cvService.cvBaseTeamInfoDetailEn({ num: this.menteeNum }).then(res => {
        if (res.data) {
          this.baseTeamInfoDetailEn = res.data
          console.log(this.baseTeamInfoDetailEn)
        }
      }).catch(error => {
        this.$ugd_message(error.message, 'error')
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
